import { Link, Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { useState } from "react";
import { useStakingInfo } from "src/hooks/useStakingInfo";
import { DelegateTokenModal } from "src/modals/DelegateTokenModal";
import { StakingPoolItemModel } from "src/models/StakingPool";
import { StakingPoolItem } from "./StakingPoolItem";
import CircularProgress from "@material-ui/core/CircularProgress";
import stakingPoolsBG from "src/assets/images/stakingPoolsBG.svg"

export const AllStakingPools = () => {
  const { items, loading } = useStakingInfo();
  const [delegateModalVisible, setDelegateModalVisible] = useState(false);
  const [selectedPoolItem, setSelectedPoolItem] = useState<
    StakingPoolItemModel | undefined
  >(undefined);

  return (
    <>
      <Box style={{
        width: "100%",  
        background: "linear-gradient(to right,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#E4F0FF)",
   
      }} display="flex" flexDirection="column" alignItems="center">
        <Box p="50px 95px 68px" width="1280px" position="relative">
          <img src={stakingPoolsBG} style={{
            top:"52px",
            right:"100px",
            position:'absolute'
          }} />
          <Typography
            fontSize="30px"
            variant="bold"
            color="#0E1011"
            lineHeight="30px"
          >
            Staking Pool
          </Typography>

          <Typography fontSize="16px" lineHeight="16px" color="#848484" mt="20px">
            How to delegate to Wetez Validator.
          </Typography>

          <Typography
            fontSize="16px"
            lineHeight="16px"
            color="#0E1011"
            mt="20px"
          >
            Step1: Find the Token Portal you want to stake
          </Typography>

          <Typography
            fontSize="16px"
            lineHeight="16px"
            color="#0E1011"
            mt="8px"
          >
            Step2: Click the Delegate button and get the delegated info
          </Typography>

          <Typography
            fontSize="16px"
            lineHeight="16px"
            color="#0E1011"
            mt="8px"
          >
            Step3: Follow the delegate info and delegate your stake, then sit
            behind and enjoy the reward
          </Typography>
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box p="50px 80px 20px" width="1280px"> 
          <Box mt="60px">
            <Typography
              fontSize="16px"
              color="white"
              borderBottom="solid 1px white"
              sx={{
                display: "inline",
              }}
            >
              Mainnet
            </Typography>
          </Box>

          {
            loading ? <Box
              height="100px"
              width="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"

            >

              <CircularProgress />
            </Box> : <Box
              mt="24px"
              minHeight="289px"
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(5, 200px)",
                rowGap: "50px",
                justifyContent: "space-between",
              }}
            >
              {items.map((item) => (
                <StakingPoolItem
                  key={item.nodeName}
                  poolItem={item}
                  onClickDelegate={() => {
                    setSelectedPoolItem(item);
                    setDelegateModalVisible(true);
                  }}
                />
              ))}

            </Box>
          }



          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mt="160px"
          >
            <Typography
              fontSize="30px"
              variant="bold"
              color="white"
              lineHeight="30px"
            >
              More projects are coming soon
            </Typography>

            <Stack direction="row" mt="4px" mb="85px" alignItems="center">
              <Typography color="#909FB5" fontSize="20px" ml="8px">
                Projects builder can invite Wetez to join as a validator
              </Typography>

              <Link
                target="_blank"
                href="https://forms.gle/zxgjAEkL59uMc29b6"
                ml="4px"
                sx={{
                  color: "#00A5F6",
                  textDecorationColor: "#00A5F6",
                }}
              >
                <Typography variant="bold" fontSize="20px" color="primary">
                  here
                </Typography>
              </Link>

              <Typography color="#909FB5" fontSize="20px">
                .
              </Typography>
            </Stack>
          </Box>
        </Box>

        <DelegateTokenModal
          visible={delegateModalVisible}
          handleClose={() => setDelegateModalVisible(false)}
          poolItem={selectedPoolItem}
        />
      </Box>
    </>
  );
};
